// extracted by mini-css-extract-plugin
module.exports = {"vimeoContainer":"youtubeVid-module--vimeoContainer--18G3l","vimeoSection":"youtubeVid-module--vimeoSection--2_3nf"};